import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id E56EAB24-6D70-49E0-BEC8-D9164A93CB63
 * name text
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text.svg
 * tags
 * - Text / Content / Format 
 */
export const TextIcon = createSvgIcon(<><path d="M21,6V8H3V6H21M3,18H12V16H3V18M3,13H21V11H3V13Z" /></>, 'TextIcon');
export default TextIcon